export const InfoWrapper = ({ children }: { children: React.ReactNode }) => (
  <div
    className="dark:border-primary dark:bg-primary rounded-xl border border-blue-200 bg-blue-100 p-6"
    data-testid="plan-trial-info"
  >
    {children}
  </div>
);
